import React from 'react';
import { Link } from 'react-router-dom';
import { LuPhone, LuMail, LuGlobe, LuInstagram, LuFacebook, LuLinkedin, LuTwitter } from 'react-icons/lu';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--forest)', color: 'var(--mist)', paddingTop: 80 }}>
      <div className="container">
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1.5fr', gap: 48, paddingBottom: 60, borderBottom: '1px solid rgba(201,168,76,0.2)' }}>

          <div>
            <Link to="/" style={{ display: 'block', marginBottom: 20 }}>
              <img 
                src="/logo-green.jpeg" 
                alt="Villa Tesori Logo" 
                style={{ height: '75px', width: 'auto' }} 
              />
            </Link>
            <p style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.05rem', fontStyle: 'italic', color: 'rgba(200,217,192,0.8)', lineHeight: 1.8, marginBottom: 20 }}>
              "Tesori" — Italian for treasure.<br />
              A Diamond Class Certified Homestay<br />
              nestled in the peaks of Wayanad.
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
              {[
                { icon: <LuInstagram />, href: 'https://www.instagram.com/villatesorihomestay/' },
              ].map((item, i) => (
                <a key={i} href={item.href} style={{
                  width: 36, height: 36, border: '1px solid rgba(201,168,76,0.3)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1rem', color: 'var(--gold)', transition: 'all 0.3s',
                  borderRadius: 2,
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(201,168,76,0.15)'; e.currentTarget.style.borderColor = 'var(--gold)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'rgba(201,168,76,0.3)'; }}
                >{item.icon}</a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ color: 'var(--gold-light)', fontFamily: 'Jost, sans-serif', fontSize: '0.72rem', letterSpacing: '0.22em', textTransform: 'uppercase', marginBottom: 20, fontWeight: 500 }}>
              Explore
            </h4>
            {[['Home','/'],['About','/about'],['Rooms','/rooms'],['Amenities','/amenities'],['Gallery','/gallery'],['Blog','/blog'],['Reviews','/reviews']].map(([label, path]) => (
              <Link key={path} to={path} style={{
                display: 'block', color: 'rgba(200,217,192,0.75)', fontSize: '0.88rem',
                marginBottom: 10, transition: 'color 0.3s',
              }}
              onMouseEnter={e => e.target.style.color = 'var(--gold-light)'}
              onMouseLeave={e => e.target.style.color = 'rgba(200,217,192,0.75)'}
              >{label}</Link>
            ))}
          </div>

          {/* Nearby */}
          <div>
            <h4 style={{ color: 'var(--gold-light)', fontFamily: 'Jost, sans-serif', fontSize: '0.72rem', letterSpacing: '0.22em', textTransform: 'uppercase', marginBottom: 20, fontWeight: 500 }}>
              Nearby
            </h4>
            {['Soojipara Waterfalls (1.5km)','Chembra Peak (15km)','Harrison Tea Factory (1.5km)','Neelimala Viewpoint (6km)','Pookode Lake (18km)','Wayanad Wildlife Sanctuary','Karapuzha Dam'].map(item => (
              <p key={item} style={{ color: 'rgba(200,217,192,0.7)', fontSize: '0.82rem', marginBottom: 8, lineHeight: 1.5 }}>
                {item}
              </p>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ color: 'var(--gold-light)', fontFamily: 'Jost, sans-serif', fontSize: '0.72rem', letterSpacing: '0.22em', textTransform: 'uppercase', marginBottom: 20, fontWeight: 500 }}>
              Find Us
            </h4>
            <p style={{ color: 'rgba(200,217,192,0.75)', fontSize: '0.88rem', lineHeight: 1.8, marginBottom: 16 }}>
              Near Soojipara Waterfalls,<br />
              Elavayal, Puthumala, Meppady,<br />
              Vellarimala, Wayanad District,<br />
              Kerala – 673577, India
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { icon: <LuPhone size={14} />, text: '+91 75588 06677', href: 'tel:+917558806677' },
                { icon: <LuMail size={14} />, text: 'villatesori@gmail.com', href: 'mailto:villatesori@gmail.com' },
                { icon: <LuGlobe size={14} />, text: 'villatesori.com', href: '#' },
              ].map(item => (
                <a key={item.text} href={item.href} style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  color: 'rgba(200,217,192,0.75)', fontSize: '0.88rem',
                  transition: 'color 0.3s',
                }}
                onMouseEnter={e => e.currentTarget.style.color = 'var(--gold-light)'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(200,217,192,0.75)'}
                >
                  <span>{item.icon}</span>{item.text}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '24px 0', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <p style={{ fontSize: '0.8rem', color: 'rgba(200,217,192,0.5)' }}>
              © {new Date().getFullYear()} Villa Tesori. Diamond Class Certified Homestay, Govt. of Kerala.
            </p>
            <p style={{ fontSize: '0.72rem', color: 'rgba(200,217,192,0.4)', letterSpacing: '0.01em' }}>
              Developed by <a href="https://adclamor.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gold-light)', textDecoration: 'none', transition: 'color 0.3s' }} onMouseEnter={e => e.target.style.color = 'var(--gold)'} onMouseLeave={e => e.target.style.color = 'var(--gold-light)'}>AdClamor digital solutions</a>
            </p>

          </div>
          <div className="footer-bottom-links" style={{ display: 'flex', gap: 24 }}>
            {['Privacy Policy', 'Terms', 'Admin'].map((item, i) => (
              <Link key={item} to={i === 2 ? '/admin/login' : '#'} style={{
                fontSize: '0.78rem', color: 'rgba(200,217,192,0.45)', transition: 'color 0.3s',
              }}
              onMouseEnter={e => e.target.style.color = 'var(--gold)'}
              onMouseLeave={e => e.target.style.color = 'rgba(200,217,192,0.45)'}
              >{item}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
